/* pe.js  -  /pages/picky-eater-guide
   No feeding formula lives here and NO AGE OR ACTIVITY MAP LIVES HERE.
   window.wynProfile.toPlan() shapes the dog, window.wynFeed.plan does every calorie.
   The only arithmetic added is the 10 percent treat ceiling and a clock.
   PASS 31: THE BAND READS THE PRIMARY DOG, NO ROSTER CHIPS. */
(function () {
  var ROOT = document.getElementById('pe');
  if (!ROOT) return;

  var BOOT = {};
  try { BOOT = JSON.parse(document.getElementById('pe-boot').textContent); } catch (e) { BOOT = {}; }

  function $(id) { return document.getElementById(id); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }
  function txt(el, s) { if (el) el.textContent = s; }
  function show(el, yes) { if (el) { if (yes) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); } } }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  var LIB_OK = !!(window.wynFeed && typeof window.wynFeed.maintenanceKcal === 'function');
  var MOD = (window.wynProfile && typeof window.wynProfile.get === 'function') ? window.wynProfile : null;
  var HAS_TOPLAN = !!(MOD && typeof MOD.toPlan === 'function');

  /* ---------------------------------------------------------------
     DISPLAY ONLY. These five factors are the recorded bus vocabulary,
     used to put a WORD next to a dog we only have a factor for.
     NOTHING HERE REACHES wynFeed. The library owns the math buckets.
  ---------------------------------------------------------------- */
  var BANDS = ['u3', 'm3to6', 'm6to12', 'adult', 'senior'];
  var BAND_FACTOR = { u3: 2, m3to6: 1.5, m6to12: 1.25, adult: 1, senior: 0.9 };
  var ACT_WORDS = ['low', 'normal', 'high'];
  var ACT_FACTOR = { low: 1.2, normal: 1.55, high: 1.75 };

  function actFromFactor(f) {
    f = Number(f);
    if (!f || isNaN(f)) return null;
    var best = null, gap = 1e9, i, k;
    for (i = 0; i < ACT_WORDS.length; i++) {
      k = ACT_WORDS[i];
      if (Math.abs(ACT_FACTOR[k] - f) < gap) { gap = Math.abs(ACT_FACTOR[k] - f); best = k; }
    }
    return best;
  }

  function bandFromMonths(m) {
    if (m == null || isNaN(m)) return null;
    if (m < 3) return 'u3';
    if (m < 6) return 'm3to6';
    if (m < 12) return 'm6to12';
    if (m < 84) return 'adult';
    return 'senior';
  }
  function bandFromFactor(f) {
    f = Number(f);
    if (!f || isNaN(f)) return null;
    var best = null, gap = 1e9, i, k;
    for (i = 0; i < BANDS.length; i++) {
      k = BANDS[i];
      if (Math.abs(BAND_FACTOR[k] - f) < gap) { gap = Math.abs(BAND_FACTOR[k] - f); best = k; }
    }
    return best;
  }

  /* ---------------- state, held in the bus vocabulary ---------------- */
  var S = {
    known: false,
    source: 'example',
    name: null,
    weight: BOOT.example_weight || 35,
    ageMonths: null,
    ageFactor: null,
    activityWord: null,
    activityFactor: null,
    neuter: null,
    colour: null,
    icon: null,
    portion: 100
  };
  var DIETS = null;
  var COUNTS = {};
  var ROSTER = null;
  var DEFAULT_ICON = null; /* the no-sticker mark, captured before it is replaced */
  var LOOKS = null;
  var ACTIVE_ID = null;
  var MEALS = 2;

  /* ---------------- the roster, READ ONLY ----------------
     The hub at /pages/user-profile owns wyn_dogs, its invariants, its
     account slots and its Raven writes. THIS PAGE NEVER WRITES IT.     */
  function readRoster() {
    var raw = null;
    try { raw = localStorage.getItem('wyn_dogs'); } catch (e) { return null; }
    if (!raw) return null;
    var r = null;
    try { r = JSON.parse(raw); } catch (e) { return null; }
    if (!r || !r.list || !r.list.length) return null;
    var living = [], i, d;
    for (i = 0; i < r.list.length; i++) {
      d = r.list[i];
      if (!d || !d.name) continue;
      if (d.status && /pass|memor/i.test(String(d.status))) continue;
      living.push(d);
    }
    if (!living.length) return null;
    return { list: living, activeId: r.activeId, primaryId: r.primaryId };
  }

  function adoptDog(d) {
    if (!d) return;
    S.name = d.name || null;
    S.colour = d.colour || null;
    S.icon = d.icon || null;
    if (d.weight_lb) { S.weight = Number(d.weight_lb); S.known = true; }
    S.ageMonths = (d.ageMonths != null) ? Number(d.ageMonths) : null;
    S.ageFactor = (d.age != null) ? Number(d.age) : null;
    S.activityFactor = (d.activity != null) ? Number(d.activity) : null;
    S.activityWord = d.activityWord || null;
    S.neuter = (d.neuter != null) ? d.neuter : null;
    S.source = 'roster';
    ACTIVE_ID = d.id;
  }

  /* ---------------- the dog's look ----------------
     Same slugs and same values as the hub, supplied as dials so the sticker
     here is the sticker there. Nothing is derived and nothing is invented:
     an unknown slug simply leaves the paw in place. */
  function pairs(str) {
    var out = {}, i, bits, parts = String(str || '').split(',');
    for (i = 0; i < parts.length; i++) {
      if (!parts[i]) continue;
      bits = parts[i].split('|');
      if (bits.length < 2) continue;
      out[bits[0].trim()] = bits.slice(1).join('|').trim();
    }
    return out;
  }
  /* the hub's own icon library, rendered onto this page as a snippet.
     ONE SOURCE: a sticker added there appears here with no change to this file. */
  function libIcons() {
    var el = document.getElementById('wup-icons');
    if (!el) return null;
    var j = null;
    try { j = JSON.parse(el.textContent); } catch (e) { return null; }
    if (!j || !j.list || !j.list.length) return null;
    var out = {}, i;
    for (i = 0; i < j.list.length; i++) {
      if (j.list[i] && j.list[i].s && j.list[i].u) out[j.list[i].s] = j.list[i].u;
    }
    return out;
  }
  function looks() {
    if (!LOOKS) {
      var lib = libIcons(), dial = pairs(BOOT.icons), k;
      /* the dial is the fallback, the library wins where both have a slug */
      if (lib) { for (k in lib) { if (Object.prototype.hasOwnProperty.call(lib, k)) dial[k] = lib[k]; } }
      LOOKS = { icons: dial, colours: pairs(BOOT.colours), lib: !!lib };
    }
    return LOOKS;
  }
  function colourOf() {
    if (!S.colour) return null;
    if (/^#[0-9a-f]{3,8}$/i.test(S.colour)) return S.colour;
    return looks().colours[S.colour] || null;
  }
  function renderLook() {
    var box = $('pe-who-ic');
    if (!box) return;
    if (DEFAULT_ICON === null) DEFAULT_ICON = box.innerHTML;

    /* the strip takes a wash of the dog's colour. Removed, not blanked, so the
       stylesheet's own fallback decides what no-colour looks like. */
    var strip = $('pe-who'), c0 = colourOf();
    if (strip) {
      if (c0) { strip.style.setProperty('--pedog', c0); }
      else { strip.style.removeProperty('--pedog'); }
    }

    var url = S.icon ? looks().icons[S.icon] : null;
    if (url) {
      box.innerHTML = '<img class="pe-who__sticker" src="' + esc(url) + '" alt="">';
      box.setAttribute('data-look', 'sticker');
      return;
    }
    /* THE COLOUR IS NOW CARRIED BY THE CARD WASH, so a coloured disc here would
       say the same thing twice. Every dog without a sticker gets the house mark. */
    box.innerHTML = DEFAULT_ICON;
    box.setAttribute('data-look', 'default');
  }

  /* ---------------- the bus ---------------- */
  function readBus() {
    if (!MOD) return;
    var p = null;
    try { p = MOD.get(); } catch (e) { p = null; }
    if (!p) return;
    if (p.weight_lb) { S.weight = Number(p.weight_lb); S.known = true; S.source = 'bus'; }
    if (p.name) S.name = p.name;
    if (p.ageMonths != null) S.ageMonths = Number(p.ageMonths);
    if (p.age != null) S.ageFactor = Number(p.age);
    if (p.activity != null) S.activityFactor = Number(p.activity);
    if (p.activityWord) S.activityWord = p.activityWord;
    if (p.neuter != null) S.neuter = p.neuter;
    if (p.portion) S.portion = Number(p.portion);
  }

  /* THIS PAGE IS READ ONLY ON DOG DATA. There is no write path at all:
     weight, age and activity are entered on the feeding calculator, which
     owns that form and writes through the same module. */

  /* ---------------- the profile handed to the library ----------------
     toPlan() is the module's own job: it omits what we do not know so the
     library applies its own defaults. We override only what this page edited. */
  function libProfile() {
    var base = {}, k;
    if (HAS_TOPLAN && S.source !== 'roster') {
      try { base = MOD.toPlan() || {}; } catch (e) { base = {}; }
    }
    var p = {};
    for (k in base) { if (Object.prototype.hasOwnProperty.call(base, k)) p[k] = base[k]; }

    p.weight_lb = S.weight;
    if (S.ageMonths != null) { p.ageMonths = S.ageMonths; delete p.ageFactor; delete p.age; }
    else if (S.ageFactor != null) { p.ageFactor = S.ageFactor; delete p.ageMonths; }
    if (S.activityWord) p.activity = S.activityWord;
    else if (S.activityFactor != null) p.activity = S.activityFactor;
    if (S.neuter != null) p.neuter = S.neuter;
    return p;
  }

  /* everything countable, ours and theirs, in one list for the totals */
  /* THE TREAT LIST LIVES IN assets/treats.js AND NOWHERE ELSE. This page used to
     carry its own copy in the boot block; it had already drifted from the treat
     calculator's copy within a day of that page existing. If the file is missing
     the ledger hides itself rather than counting against a guessed list.
     BOOT.extras_count is COPY, not data, and stays in the section. */
  var TR = (window.wynTreats && window.wynTreats.ours) ? window.wynTreats : null;
  function trOurs()   { return TR ? TR.ours : []; }
  function trCommon() { return TR ? TR.common : []; }
  function countable() { return trOurs().concat(trCommon()); }
  function usedKcal() {
    var all = countable(), t = 0, i;
    for (i = 0; i < all.length; i++) t += (COUNTS[all[i].id] || 0) * all[i].kcal;
    return t;
  }

  /* ---------------- the day's calories ----------------
     CALORIES ARE A PROPERTY OF THE DOG. `maintenanceKcal` needs no diet, which
     is why this page no longer loads or asks for one. */
  function dailyFull() {
    var wf = window.wynFeed;
    if (!wf) return 0;
    try {
      if (typeof wf.maintenanceKcal === 'function') return wf.maintenanceKcal(libProfile()) || 0;
    } catch (e) { }
    return 0;
  }

  /* ---------------- formatting ---------------- */
  function r0(n) { return Math.round(n); }
  function r1(n) { return Math.round(n * 10) / 10; }
  function band() { return bandFromMonths(S.ageMonths) || bandFromFactor(S.ageFactor) || 'adult'; }
  function bandWord(b) { return (BOOT.age_words || {})[b] || ''; }
  function actKey() { return S.activityWord || actFromFactor(S.activityFactor); }
  function actWord() {
    var k = actKey();
    if (!k) return null;
    return (BOOT.activity_words || {})[k] || k;
  }
  function fill(s, map) {
    if (!s) return '';
    return s.replace(/\{(\w+)\}/g, function (m, k) { return (map[k] != null) ? map[k] : ''; });
  }
  /* =========================================================
     RENDER
  ========================================================== */
  function renderDogLine() {
    var line, calc = $('pe-calc'), el = $('pe-dogline');
    if (!S.known) {
      line = fill(BOOT.dog_line_unknown, { weight: r1(S.weight) });
    } else {
      /* ***THE WEIGHT, AGE AND ACTIVITY READ-BACK IS GONE FROM HERE.*** It is
         already on the calculator, and the numbers below are the proof. All the
         strip owes a known customer is WHOSE numbers these are. */
      line = S.name || BOOT.no_name_word;
    }
    txt(el, line);
    /* THE BAND (pass 31): the name is set big like the weight loss page; the
       example sentence is not a name and takes the smaller style. */
    if (el) {
      if (S.known) el.classList.remove('pe-who__t--ex');
      else el.classList.add('pe-who__t--ex');
    }
    /* THE LINE ALWAYS SHOWS NOW. The roster chips are gone (pass 31: the band
       reads the PRIMARY dog, same as the weight loss page), so nothing else
       on the strip says whose numbers these are. */
    show(el, true);

    /* TWO JOBS, TWO SHAPES. With no dog on file this is the primary action and
       wears the house button. With a dog on file it is only an escape hatch, so
       it demotes to a quiet text link and stops competing with the content. */
    if (calc) {
      calc.textContent = S.known ? BOOT.calc_known : BOOT.calc_unknown;
      calc.className = S.known ? 'pe-who__calc pe-who__calc--quiet' : 'pe-who__calc';
      /* THE DESTINATION FOLLOWS THE JOB, SAME AS THE WEIGHT LOSS PAGE. With a
         dog on file "not right?" is an EDIT, so it goes to the profile; with no
         dog it is "Add your dog" and the feeding calculator is where the weight
         and age get entered. Guarded, so an older section that carries neither
         key simply keeps the href it was pasted with. */
      var dest = S.known ? (BOOT.hub_url || BOOT.calc_url) : BOOT.calc_url;
      if (dest) calc.href = dest;
    }
    show($('pe-calcnote'), !S.known);
  }

  function renderRoster() {
    /* ***PASS 31: NO CHIPS.*** The band shows the primary dog only, his call,
       matching the weight loss page. The #pe-dogs container in the section is
       kept empty and hidden so the markup can stay as pasted. */
    var wrap = $('pe-dogs');
    if (!wrap) return;
    wrap.innerHTML = '';
    show(wrap, false);
  }

  function renderControls() {
    press('pe-meals', String(MEALS));
  }
  function press(wrapId, val) {
    var w = $(wrapId);
    if (!w) return;
    var b = w.querySelectorAll('[data-v]'), i;
    for (i = 0; i < b.length; i++) {
      b[i].setAttribute('aria-pressed', b[i].getAttribute('data-v') === String(val) ? 'true' : 'false');
    }
  }

  /* The three product cards printed their kcal from Liquid, which was a fourth
     copy of the same three numbers. They come off the shared list now. */
  function paintCardKcal() {
    var o = trOurs(), i;
    for (i = 0; i < o.length && i < 3; i++) txt($('pe-pk-' + (i + 1)), String(o[i].kcal));
  }

  function renderTreats() {
    var i, full = dailyFull();
    if (!full) return;
    var allow = full * (BOOT.treat_pct || 10) / 100;

    txt($('pe-allow'), r0(allow));

    var t = trOurs();

    var all = countable(), used = usedKcal();
    for (i = 0; i < all.length; i++) {
      var c = COUNTS[all[i].id] || 0;
      var cell = $('pe-k-' + all[i].id);
      if (cell) cell.textContent = r0(c * all[i].kcal) + ' ' + BOOT.unit_kcal;
      var inp = $('pe-c-' + all[i].id);
      if (inp && document.activeElement !== inp) inp.value = c;
      var row = $('pe-r-' + all[i].id);
      if (row) row.setAttribute('data-on', c ? '1' : '0');
    }

    /* an empty bar and a "go on then" verdict are noise. Nothing appears
       until there is something to show. */
    var pct = allow > 0 ? (used / allow) * 100 : 0;
    var f = $('pe-barf');
    if (f) {
      f.style.width = Math.min(100, pct) + '%';
      f.setAttribute('data-lvl', pct > 100 ? 'over' : (pct > 75 ? 'near' : 'ok'));
    }
    show($('pe-bar'), used > 0);
    show($('pe-verdict'), used > 0);
    show($('pe-clear'), used > 0);

    /* a closed disclosure must still say how much is inside it */
    var xn = 0, x = trCommon();
    for (i = 0; i < x.length; i++) xn += (COUNTS[x[i].id] || 0);
    var xl = $('pe-extras-n');
    if (xl) {
      xl.textContent = fill(BOOT.extras_count, { n: xn });
      show(xl, xn > 0);
    }

    var over = used - allow, v;
    if (used === 0) v = '';
    else if (over <= 0 && pct <= 75) v = fill(BOOT.verdict_ok, { used: r0(used), allow: r0(allow) });
    else if (over <= 0) v = fill(BOOT.verdict_near, { used: r0(used), allow: r0(allow) });
    else v = fill(BOOT.verdict_over, {
      over: r0(over), pct: Math.max(1, Math.round(over / full * 100)),
      name: S.name || BOOT.no_name_word
    });
    txt($('pe-verdict'), v);

    /* how many of each of ours fit inside the whole budget */
    for (i = 0; i < t.length; i++) {
      var fit = $('pe-fit-' + (i + 1));
      if (!fit) continue;
      var n2 = Math.floor(allow / t[i].kcal);
      fit.textContent = n2 > 0
        ? fill(n2 === 1 ? BOOT.fit_line_one : BOOT.fit_line, { n: n2 }) : '';
    }

    txt($('pe-room'), fill(used ? BOOT.room_line : BOOT.room_line_0, {
      name: S.name || BOOT.no_name_word,
      kcal: r0(Math.max(0, allow - used)),
      allow: r0(allow)
    }));
  }

  function renderAlert() {
    var box = $('pe-alert');
    if (!box) return;
    var name = S.name || BOOT.no_name_word, b = band(), a = null;

    if (S.known && (b === 'u3' || b === 'm3to6' || b === 'm6to12')) a = { cls: 'stop', t: BOOT.alert_pup_t, p: fill(BOOT.alert_pup_p, { name: name, age: bandWord(b) }) };
    else if (S.known && S.weight < (BOOT.small_lb || 10)) a = { cls: 'stop', t: BOOT.alert_small_t, p: fill(BOOT.alert_small_p, { name: name, weight: r1(S.weight) }) };
    else if (S.known && b === 'senior') a = { cls: 'care', t: BOOT.alert_senior_t, p: fill(BOOT.alert_senior_p, { name: name }) };

    if (!a || !a.t) { box.innerHTML = ''; show(box, false); return; }
    box.className = 'pe-alert pe-alert--' + a.cls;
    box.innerHTML = '<div class="pe-alert__t">' + esc(a.t) + '</div><p class="pe-alert__p">' + esc(a.p) + '</p>';
    show(box, true);
  }


  /* =========================================================
     THE TRACKER
     A fourteen day protocol log. localStorage is the live store;
     the account copy (when the metafields exist) is a BACKUP for a
     customer who changes device. IT NEVER TOUCHES wyn_dog OR wyn_dogs.
     ***IT DOES NOT GAMIFY. There are no streaks and no congratulation
     for a dog that is not eating; refusals escalate, they never score.***
  ========================================================== */
  var TKEY = 'wyn_reset';
  var TDAYS = BOOT.track_days || 14;
  var T = null;           /* the run for the dog on screen, or null */
  var TALL = null;        /* every run, keyed by dog */
  var TSEL = null;        /* the day being edited. null means follow today. */

  function tCfg() { return BOOT.track || {}; }

  function dogKey() {
    var d = ROSTER ? null : null;
    if (ACTIVE_ID) return 'r:' + ACTIVE_ID;
    if (S.name) return 'n:' + String(S.name).toLowerCase();
    return 'local';
  }
  function today() {
    var d = new Date();
    return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
  }
  function dayNum(start) {
    var a = new Date(start + 'T00:00:00'), b = new Date(today() + 'T00:00:00');
    return Math.floor((b - a) / 86400000);
  }

  function tLoad() {
    if (TALL) return TALL;
    TALL = { v: 1, runs: {} };
    try {
      var raw = localStorage.getItem(TKEY);
      if (raw) {
        var j = JSON.parse(raw);
        if (j && j.runs) TALL = j;
      }
    } catch (e) { }
    /* the account copy seeds a run this browser has never seen */
    var acc = BOOT.track_saved || {};
    for (var k in acc) {
      if (!Object.prototype.hasOwnProperty.call(acc, k)) continue;
      if (!TALL.runs[k]) TALL.runs[k] = acc[k];
    }
    return TALL;
  }
  function tSave() {
    try { localStorage.setItem(TKEY, JSON.stringify(TALL)); } catch (e) { }
    tPush();
  }
  /* the account backup. Inert until the metafields and rids exist. */
  function tPush() {
    if (!BOOT.track_save_on) return;
    if (typeof window.peResetSave !== 'function') return;
    try { window.peResetSave(dogKey(), T); } catch (e) { }
  }

  function tRun() {
    tLoad();
    return TALL.runs[dogKey()] || null;
  }
  function tStart() {
    tLoad();
    TALL.runs[dogKey()] = { start: today(), meals: MEALS, log: {}, treats: {}, updated: Date.now() };
    T = TALL.runs[dogKey()];
    TSEL = null;
    tSave();
  }
  function tQuit() {
    tLoad();
    delete TALL.runs[dogKey()];
    T = null;
    TSEL = null;
    tSave();
  }

  function tMealsPerDay() { return (T && T.meals) ? T.meals : MEALS; }
  function tDayLog(i) {
    if (!T) return [];
    return T.log[String(i)] || [];
  }
  function tSet(dayI, mealI, code) {
    if (!T) return;
    var a = (T.log[String(dayI)] || []).slice();
    while (a.length < tMealsPerDay()) a.push('');
    a[mealI] = (a[mealI] === code) ? '' : code;
    T.log[String(dayI)] = a;
    T.updated = Date.now();
    tSave();
  }
  function tTreats(dayI, val) {
    if (!T) return;
    var cur = T.treats[String(dayI)];
    if (cur === val) delete T.treats[String(dayI)];
    else T.treats[String(dayI)] = val;
    T.updated = Date.now();
    tSave();
  }

  /* ---- escalation. Reads the LOG, not just the profile. ---- */
  function tCareful() {
    var b = band();
    if (S.known && (b === 'u3' || b === 'm3to6' || b === 'm6to12')) return true;
    if (S.known && S.weight < (BOOT.small_lb || 10)) return true;
    return false;
  }
  function tRefusedRun() {
    /* consecutive refusals counting back from the most recent logged meal */
    if (!T) return 0;
    var seq = [], i, j, a, n = Math.min(dayNum(T.start), TDAYS - 1);
    for (i = 0; i <= n; i++) {
      a = tDayLog(i);
      for (j = 0; j < a.length; j++) if (a[j]) seq.push(a[j]);
    }
    var run = 0;
    for (i = seq.length - 1; i >= 0; i--) {
      if (seq[i] === 'X') run++; else break;
    }
    return run;
  }
  function tFullDaysRefused() {
    if (!T) return 0;
    var i, a, k, all, days = 0, n = Math.min(dayNum(T.start), TDAYS - 1);
    for (i = 0; i <= n; i++) {
      a = tDayLog(i);
      if (!a.length) { days = 0; continue; }
      all = true;
      for (k = 0; k < a.length; k++) { if (a[k] !== 'X') { all = false; break; } }
      if (all && a.length >= tMealsPerDay()) days++; else days = 0;
    }
    return days;
  }
  function tAlert() {
    var name = S.name || BOOT.no_name_word, C = tCfg();
    var full = tFullDaysRefused(), run = tRefusedRun();
    if (tCareful() && (full >= 1 || run >= 2)) return { cls: 'stop', t: C.care_t, p: fill(C.care_p, { name: name }) };
    if (full >= 1) return { cls: 'stop', t: C.stop_t, p: fill(C.stop_p, { name: name }) };
    if (run >= 2) return { cls: 'care', t: C.warn_t, p: C.warn_p };
    return null;
  }

  /* ---- what their own fortnight says ---- */
  function tRead() {
    if (!T) return null;
    var C = tCfg(), i, a, k, score, meals, n = Math.min(dayNum(T.start), TDAYS - 1);
    var with_ = { eaten: 0, meals: 0, days: 0 }, without = { eaten: 0, meals: 0, days: 0 };
    for (i = 0; i <= n; i++) {
      a = tDayLog(i);
      if (!a.length) continue;
      var tv = T.treats[String(i)];
      if (tv !== 0 && tv !== 1) continue;
      score = 0; meals = 0;
      for (k = 0; k < a.length; k++) {
        if (!a[k]) continue;
        meals++;
        if (a[k] === 'E') score += 1;
        else if (a[k] === 'S') score += 0.5;
      }
      if (!meals) continue;
      var box = tv ? with_ : without;
      box.eaten += score; box.meals += meals; box.days++;
    }
    /* say nothing at all until there is something to say. A "keep logging"
       line on day one is noise, not a finding. */
    if (with_.days + without.days < 2) return null;
    if (with_.days < 2 || without.days < 2) return C.read_wait;
    var A = Math.round(without.eaten / without.meals * 100);
    var B = Math.round(with_.eaten / with_.meals * 100);
    if (Math.abs(A - B) < 10) return C.read_same;
    return fill(C.read, { name: S.name || BOOT.no_name_word, a: A, b: B });
  }

  /* ---- render ---- */
  function renderTrack() {
    var box = $('pe-track');
    if (!box) return;
    T = tRun();
    var C = tCfg();
    var started = !!T;

    show($('pe-track-go'), !started);
    show($('pe-track-gosub'), !started);
    show($('pe-track-body'), started);
    show($('pe-track-quit'), started);
    show($('pe-vet'), false);
    if (!started) { show($('pe-track-alert'), false); return; }

    var di = dayNum(T.start);
    if (di < 0) di = 0;
    var done = di >= TDAYS;
    var cur = done ? TDAYS - 1 : di;

    /* An earlier day can be picked from the grid. TSEL is only ever a day that
       has already happened; anything else falls back to today, so a stale
       selection cannot survive a dog change or a day rolling over. */
    var sel = (TSEL !== null && TSEL >= 0 && TSEL <= cur) ? TSEL : cur;

    txt($('pe-track-daynum'), fill(C.day, { n: sel + 1, total: TDAYS }));
    show($('pe-track-today'), sel !== cur);

    /* the meals for the day on screen */
    var per = tMealsPerDay(), a = tDayLog(sel), html = '', m;
    for (m = 0; m < per; m++) {
      var v = a[m] || '';
      html += '<div class="pe-track__row"><span class="pe-track__rl">' + esc(fill(C.meal, { n: m + 1 })) + '</span>' +
        '<span class="pe-track__opts" data-m="' + m + '">' +
        '<button type="button" class="pe-chip" data-c="E" aria-pressed="' + (v === 'E' ? 'true' : 'false') + '">' + esc(C.ate) + '</button>' +
        '<button type="button" class="pe-chip" data-c="S" aria-pressed="' + (v === 'S' ? 'true' : 'false') + '">' + esc(C.some) + '</button>' +
        '<button type="button" class="pe-chip" data-c="X" aria-pressed="' + (v === 'X' ? 'true' : 'false') + '">' + esc(C.none) + '</button>' +
        '</span></div>';
    }
    $('pe-track-meals').innerHTML = html;
    $('pe-track-meals').setAttribute('data-day', sel);

    var tv = T.treats[String(sel)];
    press('pe-track-treats', (tv === 0 || tv === 1) ? String(tv) : '');

    /* the fortnight grid */
    var g = '', i, j, dl, cls;
    for (i = 0; i < TDAYS; i++) {
      dl = tDayLog(i);
      g += '<button type="button" class="pe-track__d' + (i === sel ? ' is-sel' : '') +
        (i === cur ? ' is-now' : '') + '" data-i="' + i + '"' + (i > cur ? ' disabled' : '') +
        ' aria-pressed="' + (i === sel ? 'true' : 'false') + '" title="Day ' + (i + 1) + '">';
      for (j = 0; j < per; j++) {
        cls = dl[j] === 'E' ? 'e' : dl[j] === 'S' ? 's' : dl[j] === 'X' ? 'x' : 'o';
        g += '<i class="pe-track__m pe-track__m--' + cls + '"></i>';
      }
      g += '</button>';
    }
    $('pe-track-grid').innerHTML = g;

    /* escalation */
    var al = tAlert(), abox = $('pe-track-alert');
    if (al) {
      abox.className = 'pe-alert pe-alert--' + al.cls;
      abox.innerHTML = '<div class="pe-alert__t">' + esc(al.t) + '</div><p class="pe-alert__p">' + esc(al.p) + '</p>';
      show(abox, true);
    } else { abox.innerHTML = ''; show(abox, false); }

    /* the finding */
    var rd = tRead();
    txt($('pe-track-readp'), rd || '');
    show($('pe-track-readbox'), !!rd);

    renderVet();
  }

  function renderVet() {
    var wrap = $('pe-vet');
    if (!wrap || !T) return;
    var C = tCfg(), full = dailyFull();
    var facts = [
      [BOOT.vet_dog, S.name || BOOT.no_name_word],
      [BOOT.vet_weight, r1(S.weight) + ' ' + BOOT.unit_lb],
      /* the read-back that left the strip lands HERE, where a clinician
         actually wants it. It also keeps bandWord/actWord honest. */
      [BOOT.vet_age, bandWord(band())],
      [BOOT.vet_act, actWord()],
      [BOOT.vet_kcal, full ? r0(full) + ' ' + BOOT.unit_kcal : ''],
      [BOOT.vet_started, T.start]
    ], h = '', i;
    for (i = 0; i < facts.length; i++) {
      if (!facts[i][0]) continue;
      h += '<div class="pe-vet__f"><span>' + esc(facts[i][0]) + '</span><b>' + esc(facts[i][1]) + '</b></div>';
    }
    $('pe-vet-facts').innerHTML = h;

    var words = { E: C.ate, S: C.some, X: C.none }, rows = '', a, j, line;
    var n = Math.min(dayNum(T.start), TDAYS - 1);
    for (i = 0; i <= n; i++) {
      a = tDayLog(i);
      if (!a.length) continue;
      line = [];
      for (j = 0; j < a.length; j++) line.push(a[j] ? words[a[j]] : '-');
      var tv = T.treats[String(i)];
      rows += '<tr><td>' + (i + 1) + '</td><td>' + esc(line.join(', ')) + '</td><td>' +
        (tv === 1 ? 'Yes' : tv === 0 ? 'None' : '-') + '</td></tr>';
    }
    $('pe-vet-rows').innerHTML = rows;
  }

  function wireTrack() {
    on($('pe-track-start'), 'click', function () { tStart(); renderTrack(); });
    on($('pe-track-quit'), 'click', function () {
      if (window.confirm(tCfg().quit_ask || 'Erase this log?')) { tQuit(); renderTrack(); }
    });
    var mw = $('pe-track-meals');
    if (mw) mw.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('button[data-c]') : null;
      if (!b) return;
      var opts = b.parentNode;
      tSet(parseInt(mw.getAttribute('data-day'), 10), parseInt(opts.getAttribute('data-m'), 10), b.getAttribute('data-c'));
      renderTrack();
    });
    chips('pe-track-treats', function (v) {
      tTreats(parseInt($('pe-track-meals').getAttribute('data-day'), 10), parseInt(v, 10));
    });
    /* pick an earlier day out of the grid, and get back to today */
    var gw = $('pe-track-grid');
    if (gw) gw.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('button[data-i]') : null;
      if (!b || b.disabled) return;
      TSEL = parseInt(b.getAttribute('data-i'), 10);
      renderTrack();
    });
    on($('pe-track-today'), 'click', function () { TSEL = null; renderTrack(); });
    on($('pe-track-print'), 'click', function () {
      show($('pe-vet'), true);
      document.body.setAttribute('data-pe-print', 'vet');
      window.print();
      window.setTimeout(function () {
        document.body.removeAttribute('data-pe-print');
        show($('pe-vet'), false);
      }, 400);
    });
  }

  function renderAll() {
    renderLook();
    renderRoster();
    renderDogLine();
    renderControls();
    if (TR) paintCardKcal();
    if (LIB_OK && TR) renderTreats();
    renderAlert();
    renderTrack();
  }

  /* =========================================================
     BUILD
  ========================================================== */
  function rowHtml(it, cls) {
    var id = esc(it.id);
    return '<div class="' + cls + '" id="pe-r-' + id + '" data-on="0">' +
      '<div class="pe-tr__n">' + esc(it.name) + '</div>' +
      '<div class="pe-step pe-step--sm">' +
      '<button type="button" data-t="' + id + '" data-d="-1" aria-label="one fewer"><span class="pe-ic"></span></button>' +
      '<input type="number" min="0" max="99" step="1" value="0" id="pe-c-' + id + '" data-t="' + id + '" aria-label="How many ' + esc(it.name) + '">' +
      '<button type="button" data-t="' + id + '" data-d="1" aria-label="one more"><span class="pe-ic pe-ic--plus"></span></button>' +
      '</div>' +
      '<div class="pe-tr__k" id="pe-k-' + id + '">0 ' + esc(BOOT.unit_kcal) + '</div></div>';
  }

  function buildLedger() {
    var i;
    var ours = $('pe-ledger-rows'), extra = $('pe-extra-rows');
    var t = trOurs(), x = trCommon(), h = '';
    if (ours) {
      for (i = 0; i < t.length; i++) { COUNTS[t[i].id] = 0; h += rowHtml(t[i], 'pe-tr'); }
      ours.innerHTML = h;
    }
    if (extra) {
      h = '';
      for (i = 0; i < x.length; i++) { COUNTS[x[i].id] = 0; h += rowHtml(x[i], 'pe-tr pe-tr--ex'); }
      extra.innerHTML = h;
    }
  }

  /* =========================================================
     WIRING
  ========================================================== */
  function wire() {
    /* THE ONE CONTROL THAT SURVIVED THE SCHEDULE BLOCK. It decides how many
       rows a day the log asks for, so it lives with the log and it edits the
       run in place rather than only the next one. */
    chips('pe-meals', function (v) {
      MEALS = parseInt(v, 10);
      if (T) {
        T.meals = MEALS;
        for (var k in T.log) {
          if (Object.prototype.hasOwnProperty.call(T.log, k)) T.log[k] = T.log[k].slice(0, MEALS);
        }
        T.updated = Date.now();
        tSave();
      }
    });



    wireLedger($('pe-ledger-rows'));
    wireLedger($('pe-extra-rows'));

    on($('pe-clear'), 'click', function () {
      var all = countable(), i;
      for (i = 0; i < all.length; i++) COUNTS[all[i].id] = 0;
      renderTreats();
    });

    wireTrack();

    /* the fork. The "started suddenly" side is a plain anchor to #pe-flag and
       needs no script; this only reveals the reassurance on the other side. */
    on($('pe-fork-a'), 'click', function () {
      show($('pe-fork-ap'), true);
      $('pe-fork-a').setAttribute('aria-pressed', 'true');
      /* "always been fussy" folds the SYMPTOM LISTS only. The headline, the
         lead and "Call your veterinarian." stay where they were: the fork asks
         about history, the guardrail asks about symptoms, and one answer does
         not settle the other. */
      var m = $('pe-flag-more');
      if (m) m.open = false;
    });

    /* another surface changed the dog while this page is open */
    if (MOD && typeof MOD.subscribe === 'function') {
      try {
        MOD.subscribe(function () {
          if (S.source === 'roster') return;
          readBus();
          TSEL = null;
          renderAll();
        });
      } catch (e) { }
    }
  }

  function wireLedger(wrap) {
    if (!wrap) return;
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('button[data-t]') : null;
      if (!b) return;
      var id = b.getAttribute('data-t');
      COUNTS[id] = Math.max(0, Math.min(99, (COUNTS[id] || 0) + parseInt(b.getAttribute('data-d'), 10)));
      renderTreats();
    });
    wrap.addEventListener('input', function (e) {
      var i2 = e.target;
      if (!i2 || !i2.getAttribute || !i2.getAttribute('data-t')) return;
      var n = parseInt(i2.value, 10);
      if (isNaN(n) || n < 0) n = 0;
      if (n > 99) n = 99;
      COUNTS[i2.getAttribute('data-t')] = n;
      renderTreats();
    });
  }

  function chips(wrapId, fn) {
    var w = $(wrapId);
    if (!w) return;
    w.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-v]') : null;
      if (!b) return;
      fn(b.getAttribute('data-v'));
      renderAll();
    });
  }

  /* =========================================================
     BOOT
  ========================================================== */
  function start() {
    if (!LIB_OK || !TR) {
      show($('pe-treatbody'), false);
      show($('pe-figs'), false);
      show($('pe-broken'), true);
      txt($('pe-broken-file'), !LIB_OK ? (BOOT.lib_file || 'wynfeed.js') : 'treats.js');
    }

    /* ***THE PAGE READS THE PRIMARY DOG (pass 31, his call, same as the weight
       loss page).*** Order of truth: wyn_dogs.list[primaryId], then activeId,
       then the first living dog, then the shared bus. A roster dog with no
       weight keeps its name and sticker and borrows its numbers from the bus.
       THIS IS A DELIBERATE DIVERGENCE FROM THE REST OF THE SITE, WHICH FOLLOWS
       THE ACTIVE DOG. Nothing is written anywhere. */
    ROSTER = readRoster();
    if (ROSTER) {
      var pick = null, i;
      for (i = 0; i < ROSTER.list.length; i++) {
        if (ROSTER.list[i].id === ROSTER.primaryId) { pick = ROSTER.list[i]; break; }
      }
      if (!pick) for (i = 0; i < ROSTER.list.length; i++) {
        if (ROSTER.list[i].id === ROSTER.activeId) { pick = ROSTER.list[i]; break; }
      }
      adoptDog(pick || ROSTER.list[0]);
      if (!S.known) {
        var keepName = S.name, keepIcon = S.icon, keepColour = S.colour;
        readBus();
        S.name = keepName; S.icon = keepIcon; S.colour = keepColour;
      }
    } else {
      readBus();
    }

    buildLedger();
    wire();
    renderAll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();